// extracted by mini-css-extract-plugin
module.exports = {"provider-content":"I03SparkleProviderProfile_provider-content__1snnW"};